import { z } from "zod";
import { imageSchema } from "@/services/cms/cms.schema";

const stepSchema = z.object({
  title: z.string(),
  description: z.string(),
  buttonLabel: z.string().optional().nullable(),
  buttonUrl: z.string().optional().nullable(),
});

export const firstStepSchema = stepSchema.extend({
  tabs: z.array(
    z.object({
      label: z.string(),
      products: z
        .array(
          z.object({
            title: z.string(),
            description: z.string(),
            subtitle: z.string(),
            url: z.string(),
            icon: imageSchema,
          }),
        )
        .transform((arr) => arr.slice(0, 3)),
    }),
  ),
});

export const nextStepSchema = stepSchema.extend({
  image: imageSchema,
});
